// Centralised outbound links + brand constants for shyftasap.com
const SHOPIFY_STORE = "https://shyft-store.myshopify.com";

export const LINKS = {
  // Only shyftcoalition.com link allowed
  community: "https://shyftcoalition.com/?autojoin=1",

  // SmartLock consultation site
  smartlock: "https://smartlockme.com",

  // SHYFT Classes weekly class schedule
  shyftClasses: "https://shyftclasses.com/",

  // EazyBot info site
  eazybot: "https://mybotspay.me/",

  // Master Shopify store — all commercial surfaces funnel here
  store: SHOPIFY_STORE,

  // SHYFT App subscription product
  appSubscription: `${SHOPIFY_STORE}/products/shyft-app-official-mobile-platform`,

  // SHYFT Orb 1-Year License (Breakout Hunter)
  indicators: `${SHOPIFY_STORE}/products/the-shyft-orb`,
  orbBreakout: `${SHOPIFY_STORE}/products/the-shyft-orb`,

  // Apparel collection (SHYFT Gear)
  apparel: `${SHOPIFY_STORE}/collections/shyft-coalition-gear`,

  // Book of the Month collection
  books: `${SHOPIFY_STORE}/collections/book-of-the-month`,
  bookOfTheMonth: `${SHOPIFY_STORE}/collections/book-of-the-month`,

  // Monthly Book Club discussion RSVP (Mighty Networks events space)
  bookDiscussionRsvp:
    "https://shyftcoalition.com/spaces/23382052/events",

  // Mobile app store deployments (deep links for /activate)
  appStoreIOS: "https://apps.apple.com/app/shyft-coalition",
  playStoreAndroid:
    "https://play.google.com/store/apps/details?id=com.shyftcoalition.app",

  // Legal
  privacy: "/privacy",
  terms: `${SHOPIFY_STORE}/policies/terms-of-service`,
  risk: `${SHOPIFY_STORE}/pages/risk-disclaimer`,
  refund: `${SHOPIFY_STORE}/policies/refund-policy`,

  // Support
  supportEmail: "support@shyftcoalition.com",
};

export const IMAGES = {
  // Locally hosted brand assets — fixes slow remote load + caching
  brandLogo: "/coalition-emblem.png",
  heroMockup: "/shyft-app-hero.png",
  orbLogo: "/shyft-orb-logo.png",
  smartlockShield: "/smartlock-shield.png",
  eazybotLogo: "/eazybot-logo.png",

  // Existing
  shyftDefense: "/shyft-defense.png",
  forexDefense: "/forex-defense.png",
  sovereignVault: "/sovereign-vault.png",
  orbIndicator: "/orb-breakout.png",
  bookOfTheMonth: "/rich-dad-poor-dad.png",
};
